import { buildRoutePath } from 'server/utils/build-route-path';

export const fragmentName = 'header';
export const headerPath = buildRoutePath(`/fragments/${fragmentName}`);
